import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUiModule } from '../../core-ui/core-ui.module';
import { CandidateBookmarkTogglerComponent } from './candidate-bookmark-toggler.component';

@NgModule({
    imports: [CommonModule, CoreUiModule],
    declarations: [CandidateBookmarkTogglerComponent],
    exports: [CandidateBookmarkTogglerComponent]
})
export class CandidateBookmarkTogglerModule {}
